(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7505],{

/***/ 79477:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/[[...page]]",
      function () {
        return __webpack_require__(5860);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52786);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55111);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7154);
/* harmony import */ var _hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48375);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34326);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88751);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62090);
/* harmony import */ var _components_core_Head_NextHead__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46760);
/* harmony import */ var _components_Default_BreadCrumb__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3282);
/* harmony import */ var _components_ContactUs_v1_ContactUs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21088);
/* harmony import */ var _components_KeySpecifier_v1_KeySpecifier__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48440);
/* harmony import */ var _components_AssociateMembership_v1_AssociateMembership__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(518);
/* harmony import */ var _components_Literature_v1_Literature__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41773);
/* harmony import */ var _components_TechnicalSpecs_v1_TechnicalSpecs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(25778);
/* harmony import */ var _components_ProductDetail_v3_ProductAccordion__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(30534);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(81169);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(74859);
/* harmony import */ var _components_KnowledgeArticle_v1_KnowledgeArticle__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(99056);
/* harmony import */ var _components_KnowledgeArticle_v1_KnowledgeArticleFiller__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(79491);
/* harmony import */ var _components_BrowseAllStores_v1_BrowseAllStores__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(95747);
/* harmony import */ var _components_FriendsAndFamily_v1_FriendsAndFamily__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(5619);
/* harmony import */ var _components_InstallDesignServices_v1_InstallDesignServices__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(5642);
/* harmony import */ var _components_FindStore_v1_FindStore__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(41325);
/* harmony import */ var _components_ProductList_v2_ProductList__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(79903);
/* harmony import */ var _components_ProductList_v2_PLPLoader__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(80498);
/* harmony import */ var _components_Shared_UpsellInstallServices__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(24178);
/* harmony import */ var _components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(55266);
/* harmony import */ var _components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(50702);
/* harmony import */ var _components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(33273);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(46201);
/* harmony import */ var _store_features_productListSlice__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(49682);



































/**
 * renders home page
 * @return {JSX.Element}
 */ function Page(param) {
    let { tmpData: data , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analyticsData , gbhDataLayerCustom , fullUrl , urlNames , data404 , datalayerPageName , plpData ={}  } = param;
    var ref;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    const { brandLogoImg , menu: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  }  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .selectGenericState */ .Px);
    const { cartUrl  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_31__/* .selectCartState */ .xw);
    const [pageRedirect, setPageRedirect] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [isScrollMarginRequired, setIsScrollMarginRequired] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    var ref1;
    const [urlRefValue, setUrlValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("#".concat((ref1 = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("#")[1]) !== null && ref1 !== void 0 ? ref1 : ""));
    const { pageUrl ="" , redirectTarget: { page: { path =""  } = {}  } = {}  } = data;
    const { scroll: defaultScrollValue  } = _constants__WEBPACK_IMPORTED_MODULE_5__.DEFAULT_SCROLL;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    (0,_hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const cartCount = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_30__/* .getCartCount */ .c0)();
    const ariaLabel = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_30__/* .getAriaLabel */ .Xw)(t, cartCount);
    const toggleMenu = ()=>{
        if (isOpen) {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .closeMenu */ .Wj)());
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setAuthNav */ .AT)(false));
        } else {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .openMenu */ .qn)());
        }
    };
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    const eventHandler = {
        store: {
            brandLogoImg: brandLogoImg,
            isOpen,
            mainCategoryActive,
            isRegionOpen,
            isAuthNavOpen,
            cartCount,
            ariaLabel,
            cartUrl,
            plp: {
                ...plpData,
                status: "succeeded"
            }
        },
        callbacks: {
            setBrandLogoImg: (path)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setBrandLogoImg */ .XY)(path));
            },
            closeMenu: ()=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .closeMenu */ .Wj)());
            },
            setMainCategory: (payload)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setActiveMainCategory */ .X7)(payload));
            },
            toggleMenu: ()=>{
                toggleMenu();
            },
            setRegionNav: (active)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setRegionNav */ .qX)(active));
            },
            setAuthNav: (active)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setAuthNav */ .AT)(active));
            },
            setGlobalScripts: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setGlobalScripts */ .n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setGlobalStyles */ .cw)(item));
            },
            onClick: ()=>{
                redirect();
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (gbhDataLayerCustom.pageType === "plp") {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setDatalayerPageName */ .dN)(datalayerPageName));
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setGbhDataLayerCustom */ .ks)(gbhDataLayerCustom));
            if (plpData) {
                dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_32__/* .setPlpData */ .gS)({
                    ...plpData,
                    status: "succeeded",
                    initialLoad: true
                }));
            }
            return ()=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setDatalayerPageName */ .dN)(""));
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setGbhDataLayerCustom */ .ks)(""));
            };
        }
    }, [
        datalayerPageName,
        gbhDataLayerCustom,
        plpData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (pageUrl) {
            var ref, ref1, ref2, ref3;
            const containsString = _constants__WEBPACK_IMPORTED_MODULE_5__.DISABLE_SROLL_PATH.some((str)=>pageUrl.includes(str));
            var ref4;
            const installServiceHash = (ref4 = (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_5__.INSTALLATION_SERVICES_ASPATH)) && (router === null || router === void 0 ? void 0 : (ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.includes("#"))) !== null && ref4 !== void 0 ? ref4 : false;
            var ref5;
            const buyingGuideHash = (ref5 = (router === null || router === void 0 ? void 0 : (ref2 = router.asPath) === null || ref2 === void 0 ? void 0 : ref2.includes(_constants__WEBPACK_IMPORTED_MODULE_5__.BUYING_GUIDE_ASPATH)) && (router === null || router === void 0 ? void 0 : (ref3 = router.asPath) === null || ref3 === void 0 ? void 0 : ref3.includes("#"))) !== null && ref5 !== void 0 ? ref5 : false;
            if (containsString) {
                window.scrollTo({
                    top: 1,
                    behavior: "smooth"
                });
            }
            if (installServiceHash || buyingGuideHash) {
                var ref6;
                const element = (ref6 = document.querySelector("".concat(urlRefValue))) !== null && ref6 !== void 0 ? ref6 : {};
                const offsetTop = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__.getOffsetTop)(element) - defaultScrollValue;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth",
                    left: 0
                });
            }
        }
    }, [
        pageUrl,
        urlRefValue
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref, ref1;
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setGbhDataLayerCustom */ .ks)(gbhDataLayerCustom));
        if (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_5__.PRIVACY_ASPATH)) {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPageIsIntercative */ .Ys)(true));
        }
        if (router === null || router === void 0 ? void 0 : (ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.includes(_constants__WEBPACK_IMPORTED_MODULE_5__.INSTALLATION_SERVICES_ASPATH)) {
            setIsScrollMarginRequired(true);
        }
        const handleHashChange = ()=>{
            const hash = window.location.hash;
            setUrlValue(hash);
        };
        window.addEventListener("hashchange", handleHashChange);
        return ()=>{
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setGbhDataLayerCustom */ .ks)(""));
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__.getDataLayerObj)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (path) {
            setPageRedirect((0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__.removeAndCleanLink)(path));
        }
    }, [
        path
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.replace(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__.getScriptsAndStyles)(data);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            data ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Head_NextHead__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                ...data,
                fullUrl: fullUrl
            }) : null,
            header ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                header: header,
                title: data.title,
                globalScripting: globalScript
            }) : null,
            data ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                eventHandler: eventHandler,
                isScrollMarginRequired: isScrollMarginRequired,
                data: data,
                count: 0,
                breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Default_BreadCrumb__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        data: data,
                        fullData: fullData
                    }),
                productAccordion: (data, fullData)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_ProductAccordion__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        data: data,
                        fullData: fullData
                    }),
                contactUsFiller: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_KnowledgeArticle_v1_KnowledgeArticleFiller__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {}),
                contactUs: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContactUs_v1_ContactUs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        data: data
                    }),
                keySpecifier: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_KeySpecifier_v1_KeySpecifier__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        data: data
                    }),
                associateMembership: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AssociateMembership_v1_AssociateMembership__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        data: data
                    }),
                friendsAndFamily: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FriendsAndFamily_v1_FriendsAndFamily__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                        data: data
                    }),
                literature: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Literature_v1_Literature__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        data: data
                    }),
                technicalSpecifications: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "main-content",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TechnicalSpecs_v1_TechnicalSpecs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            data: data
                        })
                    }),
                knowledgeArticle: (data, urlNames)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_KnowledgeArticle_v1_KnowledgeArticle__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                        data: data,
                        urlNames: urlNames,
                        data404: data404
                    }),
                knowledgeArticleFiller: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_KnowledgeArticle_v1_KnowledgeArticleFiller__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {}),
                urlNames: urlNames,
                browseAllStores: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BrowseAllStores_v1_BrowseAllStores__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                        data: data
                    }),
                installDesignServices: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_InstallDesignServices_v1_InstallDesignServices__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                        data: data
                    }),
                findStore: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FindStore_v1_FindStore__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        data: data
                    }),
                productList: (data, eventHandler)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_ProductList__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                        data: data,
                        eventHandler: eventHandler
                    }),
                productListFiller: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat((_components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_33___default().productListWrapper), " ").concat((_components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_34___default().productTileWrapper)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_PLPLoader__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {})
                    }),
                upSellContainer: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_UpsellInstallServices__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                        authData: data
                    })
            }) : null,
            footer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                footer: footer,
                footerScripting: footerScript
            }) : null
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6351,1966,7333,8153,33,3626,1433,6051,5576,4178,3548,2404,8249,9774,2888,179], function() { return __webpack_exec__(79477); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);